module.exports = __webpack_public_path__ + "img/2gfrz1vs.29f84e60.png";